<template lang="pug">
.tab-container
  .tab-item(v-for="(item, itemIndex) in config.list" :key="itemIndex"
    :class="{'active': itemIndex === config.currentIndex}"
    @click="handleItemClick(item, itemIndex)") {{ item[labelKey] }}
</template>

<script>
export default {
  name: "ListTab",
  props: {
    config: {
      type: Object,
      default() {
        return {
          currentIndex: 0,
          list: []
        }
      }
    },
    labelKey: {
      type: String,
      default: 'label',
    }
  },
  methods: {
    handleItemClick(item, index) {
      this.$emit('update:config', {
        ...this.config,
        currentIndex: index,
      });
      this.$emit('change', {
        item,
        index,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-container{
  display: flex;
  .tab-item{
    height: 32px;
    padding: 0 22px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    color: rgba(32, 41, 72, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 12px;
    & + .tab-item{
      margin-left: 8px;
    }
    &.active{
      background: #007739;
      border: 1px solid #007739;
      color: #FFFFFF;
    }
  }
}
</style>
